import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { DropdownSearchInput } from 'molecules';
import { Label, FilterCounter, Icon } from 'atoms';
import {
  FilterHeaderWrapper, StaticWrapper, FlexCenterWrapper,
  ScrollableDropdownBodyWrapper, DropdownContentWrapper,
  RowCenterScrollWrapper, Mr2, Width200
} from 'wrappers';
import { DownCaretSvg } from 'components/icons';
import getIsMobile from "components/atoms/utils/getIsMobile";
import internalState from './internalState';
import { DropdownTextButton, ClearAllHeader, FilterCheckRow } from 'molecules';

const isMobile = getIsMobile();

const containerRef = React.createRef();
const headerRef = React.createRef();

export const definition = {
  name: 'MultiWorkerSelector',
  controller: Controller,
  initialProps: ({ workers, selectedWorkerIds, scrollLeft, label, isSingleSelect }) => ({
    workers, isSingleSelect, selectedWorkerIds, label, left: (headerRef?.current?.offsetLeft ?? 0) - (scrollLeft ?? 0)
  }),
  props: internalState,
  elements: [
    {
      wrapper: FilterHeaderWrapper,
      name: 'Selector',
      ref: headerRef,
      isButton: true,
      bindings: ({ isOpen }) => ({ isOpen, containerRef }),
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'LeftSide',
          elements: [
            {
              component: Label,
              name: 'Label',
              displayValue: ({ label }) => label ? label : 'Filter by tech: ',
            },
            {
              wrapper: wrap(RowCenterScrollWrapper, Width200),
              name: 'Wrapper',
              elements: [
                {
                  component: DropdownTextButton,
                  name: 'SelectedButton',
                  isListOf: 'selectedWorkerIds',
                  bindings: ({ selectedWorkerId, selectedWorkerIds, workers }) => {
                    let worker = workers.find(w => w.id == selectedWorkerId);
                    return { text: worker ? worker.name : '', workers, selectedWorkerIds, id: worker.id }
                  }
                }
              ]
            }
          ]
        },
        {
          wrapper: FlexCenterWrapper,
          name: 'RightSide',
          elements: [
            {
              component: wrap(FilterCounter, Mr2),
              name: 'Counter',
              renderIf: ({ isSingleSelect }) => !isSingleSelect,
              displayValue: ({ selectedWorkerIds }) => {
                const numSelected = selectedWorkerIds.length;
                return numSelected;
              },
            },
            {
              component: Icon,
              name: 'DownCaretSvg',
              displayValue: () => <DownCaretSvg />,
              bindings: ({ }) => ({})
            }
          ]
        }
      ]
    },
    {
      wrapper: ScrollableDropdownBodyWrapper,
      name: 'Body',
      ref: containerRef,
      displayState: ({ left }) => ({ left: isMobile ? '55' : left }),
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: ClearAllHeader,
          name: 'ClearAllHeader',
          renderIf: ({ isSingleSelect }) => !isSingleSelect,
          bindings: ({ selectedWorkerIds, workers }) => ({ count: selectedWorkerIds.length, selectedWorkerIds, workers })
        },
        {
          component: DropdownSearchInput,
          name: 'Search',
          bindings: ({ searchTerm }) => ({ value: searchTerm, placeholder: "Search" })
        },
        {
          wrapper: DropdownContentWrapper,
          name: 'Workers',
          elements: [
            {
              component: FilterCheckRow,
              name: 'Worker',
              isListOf: 'workers',
              renderIf: ({ worker, searchTerm }) => (new RegExp(searchTerm, 'i')).test(worker.name),
              bindings: ({ worker, selectedWorkerIds, isSingleSelect }) => {
                const isSelected = selectedWorkerIds.includes(worker.id);
                return { ...worker, isSelected, selectedWorkerIds, isSingleSelect }
              }
            },
          ]
        }
      ]
    }
  ]
}

const MultiPropertySelector = ContainerComponent(definition)

export default wrap(MultiPropertySelector, StaticWrapper);

